import { services } from '@/mocks/data';

export default function Services() {
  return (
    <section className="w-full px-6 md:px-10 py-16 md:py-20 bg-background-50">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-12">
          <p className="text-xs md:text-sm text-accent-600 tracking-[0.2em] uppercase font-label mb-3">
            Our Services
          </p>
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900">
            尊享服务体系
          </h2>
          <p className="mt-3 text-sm md:text-base text-foreground-500 max-w-xl mx-auto">
            六大核心服务体系，为精品八区会员打造全方位的高品质生活体验
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {services.map((service) => (
            <div
              key={service.title}
              className="group p-6 rounded-lg bg-background-100 border border-background-200/60 hover:border-accent-300 transition-all duration-300"
            >
              <div className="w-11 h-11 rounded-lg bg-accent-100 flex items-center justify-center mb-4 group-hover:bg-accent-500 transition-colors duration-300">
                <i className={`${service.icon} text-xl text-accent-600 group-hover:text-background-50 transition-colors duration-300`} />
              </div>
              <h3 className="text-base font-semibold text-foreground-900 mb-2">
                {service.title}
              </h3>
              <p className="text-sm text-foreground-500 leading-relaxed">
                {service.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}